module.exports = __webpack_public_path__ + "img/sticker.16547c0d.gif";